// Banks State

export default {
  banksList: [],
  fullBanksList: [],
  bankInfo: {}
}
